import { useLocation, matchPath } from 'react-router-dom';

const useRouteLayoutProps = (routes) => {
    const { pathname } = useLocation();

    const allRoutes = routes.reduce((acc, route) => {
        if (route.children)
            return [...acc, ...route.children.map(child => ({ ...child, layoutProps: route.layoutProps }))];
        return [...acc, route];
    }, []);

    for (const route of allRoutes) {
        const match = matchPath(pathname, { path: route.path, exact: true });
        if (match) return route.layoutProps || {};
    }

    return {};
};

export default useRouteLayoutProps;
